import { JSX } from "react";
import { GuideResourceItem, HelpGuidesData } from "../dashboardOverview.types";
import { DashboardCard } from "./DashboardCard";
import { DocumentIcon, ExternalLinkIcon, HelpCircleIcon, PlayCircleIcon } from "./DashboardIcons";

export interface HelpGuidesCardProps {
	data: HelpGuidesData;
	onSelectResource?: (href: string) => void;
	onStartTour?: () => void;
}

// ===== CHANGED: icon now varies by resource kind (video/guide/checklist),
// and the trailing icon is an external-link arrow instead of a chevron —
// matches the finalized reference (copy this whole block) =====
const iconByKind: Record<GuideResourceItem["kind"], JSX.Element> = {
	video: <PlayCircleIcon />,
	guide: <DocumentIcon />,
	checklist: <DocumentIcon />,
};

export const HelpGuidesCard = ({ data, onSelectResource, onStartTour }: HelpGuidesCardProps) => {
	return (
		<DashboardCard testId="help-guides-card">
			<div className="cd-card__header">
				<div className="cd-card__title">
					<HelpCircleIcon />
					<h2>Guides &amp; help</h2>
				</div>
			</div>

			<div className="cd-guide-resources">
				{data.resources.map((resource) => (
					<button
						type="button"
						key={resource.id}
						className="cd-guide-resource"
						onClick={() => onSelectResource?.(resource.href)}
					>
						<span className="cd-guide-resource__icon">{iconByKind[resource.kind]}</span>
						<span className="cd-guide-resource__text">
							<span className="cd-guide-resource__label">{resource.label}</span>
							<span className="cd-guide-resource__meta">{resource.metaLabel}</span>
						</span>
						<ExternalLinkIcon className="cd-guide-resource__chevron" />
					</button>
				))}
			</div>

			<div className="cd-guide-cta">
				<div className="cd-guide-cta__title">{data.ctaTitle}</div>
				<p className="cd-guide-cta__description">{data.ctaDescription}</p>
				<button type="button" className="cd-secondary-button cd-guide-cta__button" onClick={onStartTour}>
					{data.ctaButtonLabel}
				</button>
			</div>
		</DashboardCard>
	);
};
